// Here we will gather all enums that are used in the application and received from the server and don't belong to a specific entity

// Module
export const Module = {
  System: 0,
  Disk: 1,
  Projects: 2,
  Calendar: 3,
  Mail: 4,
  Contacts: 5,
  Admin: 6
} as const;

export type Module = (typeof Module)[keyof typeof Module];

// AccessType
export const AccessType = {
  Deny: -4096,
  OnlyUpload: -1024,
  FreeBusy: -64,
  CanDownload: -16,
  Read: 0,
  Comment: 1,
  Review: 2,
  Write: 4,
  Delete: 8,
  FullInternal: 256,
  Full: 512,
  Lock: 4096,
  LockPrint: 8192,
  LockCopy: 16384,
  LockDownload: 32768
} as const;

export type AccessType = (typeof AccessType)[keyof typeof AccessType];

// UserStatus
export const UserStatus = {
  Active: 1,
  Blocked: -2
} as const;

export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

// RoleType
export const RoleType = {
  User: 0,
  Admin: 1,
  SuperUser: 2,
  Guest: 3,
  All: 4,
  Support: 5
};

export type RoleType = (typeof RoleType)[keyof typeof RoleType];

// FilterType
export const FilterType = {
  UserStatus: 2,
  RoleType: 6,
  UserAction: 17,
  UserGender: 8
} as const;

// UserAction
export const UserAction = {
  Logout: 264,
  SuccessLogin: 260,
  LoadDoc: 121,
  ErrorAttempt: 263,
  OpenDocExternalLink: 126,
  OpenDoc: 125,
  EditDoc: 127,
  DownloadDoc: 120,
  DownloadDocLink: 124,
  CreateExternalLink: 26,
  CreateDoc: 23,
  CreateLink: 25,
  ChangeTokenDuration: 500,
  PasswordEnterCount: 501,
  AdminIpWhiteList: 502,
  UserIpWhiteList: 503,
  ChangeLdapSettings: 504,
  DeleteDocFromFolder: 180,
  DeleteDocFromGlobalTrash: 193,
  DeleteDocFromTrash: 192,
  DeleteFromFavorites: 182,
  DeleteCalendar: 19,
  DeleteDirectory: 181,
  DeleteEvent: 184,
  MoveDirectory: 190,
  RestoreDirectory: 191,
  DocumentMove: 199,
  AccessToProject: 132,
  AccessToCalendar: 131,
  AccessToEvent: 130,
  GetDocList: 41,
  AddDocToFav: 28,
  AddContactToFav: 27,
  DeleteUser: 268,
  DeleteUserWithTransfer: 269
};

export type UserAction = (typeof UserAction)[keyof typeof UserAction];

// User Gender
export const UserGender = {
  NotSpecified: 0,
  Male: 1,
  Female: 2
};

export type UserGender = (typeof UserGender)[keyof typeof UserGender];
